import type { FaireProductEntity } from "../../entity_types/product";

export const p_3aj3tb562j: FaireProductEntity = {
  token: "p_3aj3tb562j",
  type: "product",
  name: "Colorful Pine  - Customizable - Full Zip Hoodie",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/0216ed76ff0fdaf176909aa61cf42479951d0fa5de8cb3cdbd9ca9aa736b57e2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c80ed7a88e9aba2d9318ec105d88bdc2ddae9f021a1a0962fc4555bc30623113.png",
    "https://cdn.faire.com/fastly/65ceef61e0a7c73f8fb7e08bfc92b5ce611f7d50330e8c1cc3a79742015da278.png",
    "https://cdn.faire.com/fastly/f017eb809ecd7f6d88340083373219ee323f3f5711c7311cea1aeba75acc6f4b.png",
    "https://cdn.faire.com/fastly/e8fba7ea729d0fb8aff661ae1ac0d1aa5279e05e7dd7c1c2d521b44f1304c77e.png"
  ],
  priceDollars: 34,
  description: "Our soft fleece, full zip hoodie is the Perfect cover for just about any slightly chilly day.\nWe have paired it with the popular Colorful Pine graphic. This customizable graphic will be on two locations; the left chest and back of hoodie (as pictured).\n\nOur graphic is customizable up to 25 letters.\n\nThe hoodie is available Ash Gray, Heather Navy, Heather Charcoal, Heather Royal and Heather Oatmeal.\n\nSizes X-Small through 3X-Large are available.",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:48.330Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
